import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  CustomInput,
  Modal,
  ModalHeader,
  ModalBody,
  InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { connect } from 'react-redux';
import { IDoaAnswer, IAuthReduxProps, ITarget } from '../../types/interfaces';

import AssociationFields from '../vente/bien/VAssociationFields';
import TableContainer from "../tables_manager/TableContainer"
import EditableCell from "../tables_manager/EditableCell";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { answerDoa } from '../../flux/actions/doaActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faExternalLinkAlt, faPen, faSpinner, faLockOpen, faSyncAlt, faCommentsDollar, faMoneyBill, faRulerCombined, faSquare, faCheckSquare, faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';
import { PRIVILEGE } from '../../types/privileges'
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";
import ReactTooltip from 'react-tooltip';
import Association from '../consultation/Association';

const DoaDelete = ({
  modal,
  setModal,
  handleToggle,
  modalDoa,
  answerDoa,
  answer,
  auth
 }: IDoaAnswer) => {
  const alert = useAlert();

  const [idValue, setIdValue] = useState(-1);
  const [bienValue, setBienValue] = useState<any>('');
  const [doaNewPriceValue, setDoaNewPriceValue] = useState(0);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [reEnable, setReEnable] = useState(false);
  
  const [newPriceValue, setNewPriceValue] = useState(0);
  const [newPriceTotalValue, setNewPriceTotalValue] = useState(true);
  const [newPriceFlag, setNewPriceFlag] = useState(false);
  const newPriceRef = useRef<HTMLInputElement>(document.createElement("input"));
  
  const typeOptions = [{value: "APPARTEMENT", label: "Appartement"}, {value: "MAGASIN", label: "Magasin"}];
  const [selectedFloor, setSelectedFloor] = useState<any>();
  const [selectedDivisionType, setSelectedDivisionType] = useState<any>();
  const [selectedDivisionPercent, setSelectedDivisionPercent] = useState<any>();
  const [etageValue, setEtageValue] = useState<any>('');
  const [typeValue, setTypeValue] = useState<any>('');
  const [positionValue, setPositionValue] = useState('');
  const [percentValue, setPercentValue] = useState(0);
  const [superficieValue, setSuperficieValue] = useState(0);
  const [prixpartValue, setPrixpartValue] = useState(0);
  const [partCommentValue, setPartCommentValue] = useState('');
  const [association, setAssociation] = useState<any>(undefined);
  
  const selectedFloorFlag = useRef(true)
  const selectedDivisionTypeFlag = useRef(true)
  const selectedDivisionPercentFlag = useRef(true)
  
  const [saveSample, setSaveSample] = useState(false);
  const [sampleName, setSampleName] = useState('');

  const sampleNameChangeHandler = (e: ITarget) => setSampleName(e.target.value);

  const newPriceChangeHandler = (e/*: ITarget*/) => {
    const doubleValue = e.target.value ? e.target.value.toString().replace(",", ".") : 0,
      splits = doubleValue.toString().split(".");
    if(!isNaN(doubleValue) && +doubleValue >= 0){
      const res = splits.length === 2 && splits[1] !== "" ? Number((+doubleValue).toFixed(2)) : doubleValue;
      setNewPriceValue(res);
    }
    else if(e.target.value === "")
      setNewPriceValue(0)
  };

  const changeNewPriceTotal = (e: boolean) => {
    if(e){
      if(!newPriceTotalValue){
        setNewPriceTotalValue(true);
        setNewPriceValue(Number(newPriceValue) * ((bienValue?.contrat ? bienValue.contrat.SUPERFICIE : bienValue?.SUPERFICIE) ? Number(bienValue?.contrat ? bienValue.contrat.SUPERFICIE : bienValue?.SUPERFICIE) : 1))
      }
    }
    else{
      if(newPriceTotalValue){
        setNewPriceTotalValue(false);
        setNewPriceValue(Number(newPriceValue) / ((bienValue?.contrat ? bienValue.contrat.SUPERFICIE : bienValue?.SUPERFICIE) ? Number(bienValue?.contrat ? bienValue.contrat.SUPERFICIE : bienValue?.SUPERFICIE) : 1))
      }
    }
  }

  useEffect(() => {
    if(!newPriceFlag)
      setNewPriceFlag(true)
    else if(newPriceValue === 0 && newPriceRef?.current)
      newPriceRef.current.select()
  }, [newPriceValue]);

  useEffect(() => {
    setAssociation({
      selectedFloor,
      selectedDivisionType,
      selectedDivisionPercent,
      ETAGE: selectedFloor?.floor,
      TYPE: typeValue ? typeValue["isNew"] ? typeValue["name"] : typeValue.value : undefined,
      POSITION: positionValue,
      POURCENTAGE: !bienValue?.division ? percentValue : selectedDivisionPercent?.percent,
      SUPERFICIE: superficieValue,
      PRIX_VENTE: prixpartValue,
      OBSERVATION: partCommentValue,
    })
  }, [selectedFloor, selectedDivisionType, selectedDivisionPercent, typeValue, positionValue, percentValue, superficieValue, prixpartValue]);

  const focusHandler = (e) => {
    if(e.target.value == "0")
      e.target.select();
  };

  useEffect(() => {
    if (selectedFloorFlag.current) {
      selectedFloorFlag.current = false;
      return;
    }
    setSelectedDivisionType(undefined)
    if(selectedFloor?.activePartitionTypeId)
      setSelectedDivisionType(selectedFloor.activePartitionType || '')
  }, [selectedFloor])

  useEffect(() => {
    if (selectedDivisionTypeFlag.current) {
      selectedDivisionTypeFlag.current = false;
      return;
    }
    setSelectedDivisionPercent(undefined)
  }, [selectedDivisionType])

  useEffect(() => {
    if (selectedDivisionPercentFlag.current) {
      selectedDivisionPercentFlag.current = false;
      return;
    }
    setPrixpartValue(0)
  }, [selectedDivisionPercent])

  // useEffect(() => {
  //   if(modalDoa?.isSentToAss && selectedFloor)
  //     setSelectedDivisionType(modalDoa.division_partition_type || '')
  // }, [selectedFloor])

  // useEffect(() => {
  //   if(modalDoa?.isSentToAss && selectedDivisionType)
  //     setSelectedDivisionPercent(modalDoa.division_partition_type_percent || '')
  // }, [selectedDivisionType])

  // useEffect(() => {
  //   if(modalDoa?.isSentToAss && selectedDivisionPercent)
  //     setPrixpartValue(modalDoa.ass_PRIX_VENTE)
  // }, [selectedDivisionPercent])

  const modalOpenedHandle = () => {
    setNewPriceTotalValue(true);
    if(modalDoa && modalDoa !== ''){
      selectedFloorFlag.current = true;
      selectedDivisionTypeFlag.current = true;
      selectedDivisionPercentFlag.current = true;
      setIdValue(modalDoa["id"]);
      setBienValue(modalDoa["bien"]);
      setDoaNewPriceValue(modalDoa["new_price"]);
      setNewPriceValue(modalDoa["new_price"]);
      
      if(modalDoa.isSentToAss){
        // setEtageValue({value: modalDoa.ass_ETAGE, label: modalDoa.ass_ETAGE == 0 ? "RDC" : modalDoa.ass_ETAGE} || '');
        setSelectedFloor(modalDoa.division_floor || '');
        setSelectedDivisionType(modalDoa.division_partition_type || '');
        // setSelectedDivisionPercent(modalDoa.division_partition_type?.division_partition_type_percents?.find(e => e.percent == modalDoa.ass_POURCENTAGE) || '');
        setSelectedDivisionPercent(modalDoa.division_partition_type_percent || '');
        // setTypeValue(modalDoa.ass_TYPE);
        setTypeValue(modalDoa.ass_TYPE ? typeOptions.find(e => e.value === modalDoa.ass_TYPE) ? {value: modalDoa.ass_TYPE, label: typeOptions.find(e => e.value === modalDoa.ass_TYPE)?.label || ""} : {name: modalDoa.ass_TYPE, isNew: true} : '');
        setPositionValue(modalDoa.ass_POSITION);
        // setPercentValue(modalDoa.ass_POURCENTAGE);
        setSuperficieValue(modalDoa.ass_SUPERFICIE);
        setPrixpartValue(modalDoa.ass_PRIX_VENTE);
      }
      else{
        setEtageValue('');
        setTypeValue('');
        setPositionValue('');
        setPercentValue(0);
        setSuperficieValue(0);
        setPrixpartValue(0);
      }
    }
  };

  const modalClosedHandle = () => {
    setIdValue(-1);
    setBienValue('');
    setDoaNewPriceValue(0);
    setNewPriceValue(0);
    if(reEnable){
      setDisableSubmit(false);
      setReEnable(false);
    }
  };

  const callback = (success, approved) => {
    if(success){
      setReEnable(true);
      setModal(false);
      alert.success(`Demande ${approved ? "acceptée" : "refusée"} avec succès`);
      return
    }
    alert.error("Une erreur s'est produite");
    setDisableSubmit(false);
  }

  const answerHandle = async () => {
    if(idValue === -1)
      return
    if(modalDoa?.isSentToAss){
      if(!association){
        alert.error("Veuillez saisir les informations de l'association");
        return
      }
      if(association.ETAGE === undefined){
        alert.error("Veuillez sélectionner un étage");
        return
      }
      if(association.TYPE === undefined){
        alert.error("Veuillez sélectionner le type de l'association");
        return
      }
      if(!association.POURCENTAGE){
        alert.error("Veuillez saisir un pourcentage");
        return
      }
      if(!association.PRIX_VENTE){
        alert.error("Veuillez saisir le prix de vente de l'association");
        return
      }
    }
    if(saveSample && !sampleName){
      alert.error("Veuillez saisir un nom");
      return
    }
    setDisableSubmit(true);
    answerDoa(idValue, bienValue["id"], answer, Number((newPriceTotalValue ? (Number(newPriceValue) / ((bienValue?.contrat ? bienValue.contrat.SUPERFICIE : bienValue?.SUPERFICIE) ? Number(bienValue?.contrat ? bienValue.contrat.SUPERFICIE : bienValue?.SUPERFICIE) : 1)) : Number(newPriceValue)).toFixed(2)), Number((newPriceTotalValue ? Number(newPriceValue) : (Number(newPriceValue) * ((bienValue?.contrat ? bienValue.contrat.SUPERFICIE : bienValue?.SUPERFICIE) ? Number(bienValue?.contrat ? bienValue.contrat.SUPERFICIE : bienValue?.SUPERFICIE) : 1))).toFixed(2)), modalDoa?.isSentToAss ? association : undefined, saveSample ? 1 : 0, sampleName, auth?.user && auth?.user.id ? auth?.user.id : undefined, auth?.user && auth?.user.username ? auth?.user.username : undefined, callback);
  };

  return (
    <div>
      <Modal isOpen={modal} toggle={handleToggle} onOpened={modalOpenedHandle} onClosed={modalClosedHandle} className="modal-dialog-large">
        <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faLockOpen} />&nbsp;&nbsp;Demande d'ouverture en association</ModalHeader>
        <ModalBody>
            <Container className="linesConfirmationContainer">
              <Row className="mb-2">
                Voulez-vous vraiment&nbsp;<b>{answer ? "accepter" : "refuser"}</b>&nbsp;la demande d'ouverture en association du bien&nbsp;<b>{bienValue ? bienValue["DESIGNATION"] : ""}</b>&nbsp;?
              </Row>
              {answer ? <Row>
                <Col xs="12">
                  <FontAwesomeIcon icon={faRulerCombined} />&nbsp;Superficie : <span style={{fontWeight: 600}}>{(bienValue?.contrat ? bienValue.contrat.SUPERFICIE : bienValue?.SUPERFICIE) ? ((bienValue?.contrat ? bienValue.contrat.SUPERFICIE : bienValue?.SUPERFICIE) + "m²") : "-"}</span>
                </Col>
              </Row> : null}
              {answer ? <Row>
                <Col xs="12">
                  <FontAwesomeIcon icon={faMoneyBill} />&nbsp;Ancien prix {modalDoa?.isSentToAss ? "de vente" : "du bien"} : <span style={{fontWeight: 600}}>{(((bienValue?.contrat ? bienValue.contrat.PRIX_NET : bienValue?.PRIX_VENTE) || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh")}{(bienValue?.contrat ? bienValue.contrat.PRIX_M : bienValue?.PRIX_M) ? (" (" + ((bienValue?.contrat ? bienValue.contrat.PRIX_M : bienValue?.PRIX_M) || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh/m²)") : ""}</span>
                </Col>
              </Row> : null}
              {answer ? <Row>
                <Col xs="12">
                  <FontAwesomeIcon icon={faCommentsDollar} />&nbsp;Prix de l'association proposé : <span style={{fontWeight: 600}}>{(doaNewPriceValue !== null && doaNewPriceValue !== undefined) ? (doaNewPriceValue.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"}{" (" + (Number(doaNewPriceValue) / Number((bienValue?.contrat ? bienValue.contrat.SUPERFICIE : bienValue?.SUPERFICIE) || 1)).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh/m²)"}</span>
                </Col>
              </Row> : null}
              {answer ? <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="new_price"><FontAwesomeIcon icon={faCheckCircle} />&nbsp;Nouveau prix de l'association</Label>
                    <span style={{display: "inline-block", whiteSpace: "nowrap"}}>
                      <span className={`bienCardRadio${!newPriceTotalValue ? " selectedBCRadio" : ""}`} onClick={() => changeNewPriceTotal(false)}><FontAwesomeIcon icon={!newPriceTotalValue ? faCheckSquare : faSquare} />&nbsp;du m²</span>
                      <span className={`bienCardRadio${newPriceTotalValue ? " selectedBCRadio" : ""}`} onClick={() => changeNewPriceTotal(true)}><FontAwesomeIcon icon={newPriceTotalValue ? faCheckSquare : faSquare} />&nbsp;du total</span>
                    </span>
                    &nbsp;&nbsp;<FontAwesomeIcon icon={faSyncAlt} style={{cursor: "pointer", fontSize: "small"}} onClick={() => {setNewPriceTotalValue(true); setNewPriceValue(doaNewPriceValue || 0);}} data-tip data-for="resetNewPricetooltip" />
                    <ReactTooltip effect="solid" id="resetNewPricetooltip" type={"dark"}>
                      Réinitialiser le prix
                    </ReactTooltip>
                    <InputGroup className="quantityInputGroup">
                      <Input id="new_price" type="number" pattern="[0-9]*" disabled invalid={newPriceTotalValue ? (Number(bienValue?.contrat ? bienValue.contrat.PRIX_NET : bienValue?.PRIX_VENTE) > Number(newPriceValue) || Number(newPriceValue) >= Number(bienValue?.contrat ? bienValue.contrat.PRIX_NET : bienValue?.PRIX_VENTE) * 10) : (Number(bienValue?.contrat ? bienValue.contrat.PRIX_M : bienValue?.PRIX_M) > Number(newPriceValue) || Number(newPriceValue) >= Number(bienValue?.contrat ? bienValue.contrat.PRIX_M : bienValue?.PRIX_M) * 10)} placeholder="Nouveau prix de l'association..." innerRef={newPriceRef} value={Number(newPriceValue).toString()} onFocus={focusHandler} onChange={newPriceChangeHandler} className="form-control" />
                      <InputGroupAddon addonType="append">
                        <InputGroupText>DH</InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>
                  </FormGroup>
                </Col>
              </Row> : null}
              {answer && modalDoa?.isSentToAss ? <Row className="mt-4">
                <Col xs="12">
                  <AssociationFields isDoa={true} isDoaAnswer selectedBien={bienValue} selectedFloor={selectedFloor} setSelectedFloor={setSelectedFloor} selectedDivisionType={selectedDivisionType} setSelectedDivisionType={setSelectedDivisionType} selectedDivisionPercent={selectedDivisionPercent} setSelectedDivisionPercent={setSelectedDivisionPercent} etageValue={etageValue} setEtageValue={setEtageValue} typeValue={typeValue} setTypeValue={setTypeValue} positionValue={positionValue} setPositionValue={setPositionValue} percentValue={percentValue} setPercentValue={setPercentValue} superficieValue={superficieValue} setSuperficieValue={setSuperficieValue} prixpartValue={prixpartValue} setPrixpartValue={setPrixpartValue} commentValue={partCommentValue} setCommentValue={setPartCommentValue} />
                </Col>
              </Row> : null}
              <Row>
                <Col xs="12">
                  <h6 className="text-center" style={{color: !bienValue?.division ? "red" : bienValue.division.approved === 1 ? "green" : "orange"}}>{bienValue?.division ? bienValue.division.approved === 1 ? "Répartition validée" : "Répartition pas encore validée" : "Aucune répartition n'est proposée"}</h6>
                  {!!bienValue?.division && <Association etages={bienValue.ETAGE_ASS} division={bienValue.division} />}
                </Col>
              </Row>
              {!!(auth?.user?.privileges?.includes(PRIVILEGE.APPROVE_DIVISION) && bienValue?.division && !bienValue?.division?.divisionSampleId) && <div className="fullFlexCenter">
                <CustomInput type="switch" id="saveSample" name="saveSampleSwitch" label="Enregistrer un nouveau groupe" checked={saveSample} onChange={e => setSaveSample(e.target.checked)} />
              </div>}
              {!!saveSample && <Row className="justify-content-center">
                <Col xs="12" sm="4" style={{border: "none"}}>
                  <Input id="sampleName" type="text" placeholder="Nom du Groupe..." value={sampleName} onChange={sampleNameChangeHandler} className="form-control" />
                </Col>
              </Row>}
              <Row className="justify-content-center">
                <Button
                  className={`btn btn-${answer ? "success" : "danger"} linesConfirmationBtn linesDeleteBtn`}
                  onClick={answerHandle}
                  disabled={disableSubmit || !auth?.user?.privileges?.includes(PRIVILEGE.APPROVE_DIVISION)}
                  ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faLockOpen} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;{answer ? "Accepter" : "Refuser"}</Button>
              </Row>
            </Container>
        </ModalBody>
      </Modal>
    </div>  
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error
});

export default connect(mapStateToProps, { answerDoa })(DoaDelete);
